export default "__VITE_ASSET__DsOC6Ue___"